module.exports = __webpack_public_path__ + "img/1-8.8672e8b4.svg";